import { sortMembersByType, teamsClient } from '@atlaskit/teams-client';

import { promiseWithDefault } from '../../../common/utils/promise';
import type { StoreApi, TeamAppState } from '../types';

export const getMyTeamMembership =
	(teamId: string, keepExistingData?: boolean) =>
	async ({ getState, setState }: StoreApi): Promise<void> => {
		if (!keepExistingData) {
			setState({
				myTeamMembership: {
					teamId,
					hasLoaded: false,
					membership: undefined,
				},
			});
		}

		const { myTeamMembership } = getState();

		if (myTeamMembership.teamId !== teamId) {
			return;
		}

		const { value: membership } = await promiseWithDefault(
			teamsClient.getMyTeamMembership(teamId),
			undefined,
		);

		const { teamMembers } = getState();

		const members = teamMembers.members;

		const sortedMembers: Partial<TeamAppState> =
			members.length > 0 && !!membership
				? {
						teamMembers: {
							...teamMembers,
							members: sortMembersByType(members, membership.membershipId.memberId),
						},
					}
				: {};

		setState({
			myTeamMembership: {
				teamId,
				hasLoaded: true,
				membership,
			},
			...sortedMembers,
		});
	};
